import { useLingui } from "@lingui/react/macro";
import { useIsWorkingMode } from "@/contexts/AppModeContext";

/** One line above Cooking now that says the rows can be ticked for Multi View (YC-23). */
export function MultiViewHint() {
  const { t } = useLingui();
  const working = useIsWorkingMode();
  if (!working) return null;
  return (
    <p className="px-3 text-sm text-(--color-text-secondary)" data-testid="multi-view-hint">
      {t`Tick recipes to watch them together in Multi View`}
    </p>
  );
}
